import { ResetPasswordController as controller } from './resetPassword.controller';
import template from './resetPassword.html';
import '../../common/ui/componentHeader/componentHeader';

export const resetPasswordComponent = {
  name: 'resetPasswordComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<'
  }
};
